import React, { useState } from "react";
import "./WordBuilder.css";

const words = [
  { clue: "A yellow fruit", answer: "BANANA" },
  { clue: "A red fruit", answer: "APPLE" },
  { clue: "It flies in space", answer: "ROCKET" },
];

export default function WordBuilder() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [letters, setLetters] = useState(shuffle(words[0].answer.split("")));
  const [builtWord, setBuiltWord] = useState([]);
  const [message, setMessage] = useState("");
  const [score, setScore] = useState(0);
  const [selectedLetter, setSelectedLetter] = useState(null); // for mobile tap

  // Sounds
  const correctSound = new Audio("/sounds/correct.mp3");
  const wrongSound = new Audio("/sounds/wrong.wav");
  const winSound = new Audio("/sounds/win.mp3");

  function shuffle(array) {
    return array.sort(() => Math.random() - 0.5);
  }

  const handleDrop = (letter) => {
    if (!letter) return;
    const newWord = [...builtWord, letter];
    setBuiltWord(newWord);

    if (newWord.length === words[currentIndex].answer.length) {
      if (newWord.join("") === words[currentIndex].answer) {
        setMessage("🎉 Correct!");
        setScore(score + 10);
        correctSound.play();
        if (currentIndex + 1 < words.length) {
          setTimeout(() => {
            setCurrentIndex(currentIndex + 1);
            setLetters(shuffle(words[currentIndex + 1].answer.split("")));
            setBuiltWord([]);
            setMessage("");
          }, 1000);
        } else {
          setMessage("🏆 You solved all words!");
          winSound.play();
        }
      } else {
        setMessage("❌ Wrong word!");
        setScore(score - 5);
        wrongSound.play();
        setTimeout(() => setBuiltWord([]), 1000);
      }
    }
  };

  return (
    <div className="builder-container">
      <h1>🔤 Word Builder</h1>
      <p className="clue">Clue: {words[currentIndex].clue}</p>

      <div className="letters">
        {letters.map((letter, i) => (
          <div
            key={i}
            className={`letter ${selectedLetter === letter ? "selected" : ""}`}
            draggable
            onDragStart={(e) => e.dataTransfer.setData("text", letter)}
            onClick={() => setSelectedLetter(letter)} // mobile tap
          >
            {letter}
          </div>
        ))}
      </div>

      <div
        className="drop-zone"
        onDragOver={(e) => e.preventDefault()}
        onDrop={(e) => handleDrop(e.dataTransfer.getData("text"))}
        onClick={() => {
          if (selectedLetter) {
            handleDrop(selectedLetter);
            setSelectedLetter(null);
          }
        }} // mobile tap drop
      >
        {builtWord.map((l, i) => (
          <span key={i} className="built-letter">{l}</span>
        ))}
      </div>

      <p className="status">{message}</p>
      <p className="score">⭐ Score: {score}</p>
    </div>
  );
}
